import React,{useEffect, useState, useRef} from 'react'
import { useNavigate } from "react-router-dom";
import { useSelector,useDispatch } from "react-redux";
import { getActivePrice } from "../../utils/converter";
import {getAllProductsAction} from "../../store/product/actions"
import Layout from "../layout/Layout"
import Productsskeleton from "./Productsskeleton"
import {getProducts,productreset} from "../../store/product/productSlice"

import './products.css';



const Products = () => {
  const [page, setPage] = useState(1);
  // const { product } = useSelector((state: any) => state);
  const { products, isLoading, isSuccess, isError, message } = useSelector((state: any) => state.product);

  const [productData, setProductData] = useState(products);
  const [loading, setLoading] = useState(true);
  const [count, setCount] = useState(0);
//  const prodct = useRef(products);
  const navigate = useNavigate();
  const dispatch = useDispatch<any>();
  const newProducts = productData;

  const totalPages = Math.ceil(products?.length / 9);
  
 

  const handleScroll = () => {
    if((window.innerHeight + document.documentElement.scrollTop + 1) >= document.documentElement.scrollHeight){
      // setLoading(true);
      setPage((prev:any) => prev + 1);
      
    }
  }

  useEffect(() => {
    // Fetch more products when the page state changes
    if (page > 0) {
      dispatch(getProducts(`?limit=9&page=${page}&status=Active`));
      // console.log(`if-------page:${page} , productDats:${productData}`)

    }
  }, [page, dispatch]);

  

  

  useEffect(() => {
    window.addEventListener("scroll",handleScroll);
    if(page===1){
      dispatch(productreset())

    }
    return () => window.removeEventListener("scroll",handleScroll);
  },[])

  const allProducts = products.reduce((acc:any, current:any) => acc.concat(current), []);
  //  const allProducts:any =  [...newProducts, products];
  return (
    <Layout>
      <div className="products-catagories-area clearfix" >
        
        <div className="amado-pro-catagory clearfix" id="amado-pro-catagory">
        
          
          
         {allProducts?.map((d: any, index: number) => (
              <div className="single-products-catagory clearfix " id="single-products-catagory" key={index} onClick={() => navigate(`/shop/${d?.product}/${d?._id}`)}>
                    <a href="#">
                        <img src={d?.images[0]} alt=""/>
                        <div className="hover-content">
                            <div className="line"></div>
                            <p>{`RWF ${getActivePrice(d?.prices)?.toLocaleString()}`}</p>
                            <h4>{d?.product}</h4>
                        </div>
                    </a>
              </div>
          ))}

          {isLoading && <Productsskeleton cards={6}/> } 
         
        </div>
     </div>
    </Layout>
  )
}

export default Products